import { render, staticRenderFns } from "./ClassReports.vue?vue&type=template&id=4f385e1a&scoped=true"
import script from "./ClassReports.vue?vue&type=script&lang=js"
export * from "./ClassReports.vue?vue&type=script&lang=js"
import style0 from "./ClassReports.vue?vue&type=style&index=0&id=4f385e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f385e1a",
  null
  
)

export default component.exports